import React, { Component } from 'react';
import Login from '../components/Login';

class Connexion extends Component {

  render() {
    return (
      <>
        <div>
          <Login />
        </div>
      </>
    );
  }
}

export default Connexion;
